var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('create-new-folder', {
    attrs: {
      "data-to-show": _vm.isCreateFolderPopupDisplayed,
      "errors": _vm.errorsCreateNewFolder
    },
    on: {
      "showChange": function (val) {
        _vm.displayPopupAddNewFolder(val);
      },
      "createNewFolder": function (folder) {
        _vm.createFolder(folder);
      }
    }
  }), _vm._v(" "), _c('edit-folder', {
    attrs: {
      "data-to-show": _vm.isEditFolderPopupDisplayed,
      "errors": _vm.errorsEditFolder,
      "folder": _vm.folderToEdit
    },
    on: {
      "showChange": function (val) {
        _vm.displayPopupEditFolder(val);
      },
      "editFolder": function (folderEdited) {
        _vm.editFolder(folderEdited);
      }
    }
  }), _vm._v(" "), _c('delete-folder', {
    attrs: {
      "data-to-show": _vm.isDeleteFolderPopupDisplayed,
      "errors": _vm.errorsDeleteFolder,
      "folder": _vm.folderToDelete
    },
    on: {
      "close": function ($event) {
        return _vm.displayPopupDeleteFolder(false);
      },
      "deleteFolder": function ($event) {
        return _vm.deleteFolder();
      }
    }
  }), _vm._v(" "), _c('move-folder', {
    attrs: {
      "data-to-show": _vm.isMoveFilePopupDisplayed,
      "file-to-move": _vm.fileToMove,
      "errors": _vm.errorsMoveFile
    },
    on: {
      "showChange": function (val) {
        _vm.displayPopupMoveFile(val);
      },
      "moveFile": function (file) {
        _vm.moveFile(file);
      }
    }
  }), _vm._v(" "), _c('add-member', {
    attrs: {
      "data-to-show": _vm.isAddMemberPopupDisplayed,
      "folder": _vm.folderToShare,
      "errors": _vm.errorsAddMemberFolder
    },
    on: {
      "showChange": function (val) {
        _vm.displayPopupAddMember(val);
      },
      "addMembers": function (members) {
        _vm.addMembers(members);
      },
      "editUserRights": function (user, newRights) {
        _vm.editUserRights(user, newRights);
      },
      "editRoleRights": function (role, newRights) {
        _vm.editRoleRights(role, newRights);
      },
      "revokeUserRights": function (user) {
        _vm.revokeUserRights(user);
      },
      "revokeRoleRights": function (role) {
        _vm.revokeRoleRights(role);
      }
    }
  }), _vm._v(" "), _c('add-new-file', {
    attrs: {
      "data-to-show": _vm.stateAddFilePopup,
      "loading": _vm.addNewFileLoading,
      "file-temp": _vm.fileTemp,
      "errors": _vm.errorsAddNewFile
    },
    on: {
      "showChange": function (val) {
        _vm.changeStatePopupAddNewFile(val);
      },
      "addTempFile": function (data) {
        _vm.addTempFile(data);
      },
      "addFile": function (infos) {
        _vm.addFile(infos);
      }
    }
  }), _vm._v(" "), _c('edit-file', {
    attrs: {
      "data-to-show": _vm.isEditFilePopupDisplayed,
      "errors": _vm.errorsEditFile,
      "file": _vm.fileToEdit
    },
    on: {
      "showChange": function (val) {
        _vm.displayPopupEditFile(val);
      },
      "editFile": function (fileEdited) {
        _vm.editFile(fileEdited);
      }
    }
  }), _vm._v(" "), _c('preview-file', {
    attrs: {
      "data-to-show": _vm.isPreviewPopupDisplayed,
      "file": _vm.fileToDisplay
    },
    on: {
      "close": function ($event) {
        return _vm.displayPopupPreview(false);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "px-6 md:px-12"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('h4', {
    staticClass: "text-indigo-600 text-left"
  }, [_vm._v("\n        Dossiers récents\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow"
  }), _vm._v(" "), _vm.folders.length > 0 ? _c('div', [_c('h5', {
    staticClass: "text-gray-900 text-right cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.openFolder();
      }
    }
  }, [_vm._v("\n          Voir tout\n        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "my-10"
  }, [_vm.canEdit && _vm.$can(_vm.constants.PERMISSION_DEPOT_DOCUMENTS_CREATE) ? _c('add-button', {
    attrs: {
      "libelle": "Ajouter un nouveau dossier"
    },
    on: {
      "add": function ($event) {
        return _vm.displayPopupAddNewFolder(true);
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-3 gap-12 mb-12"
  }, _vm._l(_vm.rootFolders.filter(function (f, i) {
    return i < 3;
  }), function (folder, numFolder) {
    return _c('div', {
      key: numFolder,
      staticClass: "col-span-full md:col-span-1"
    }, [_c('folder-card', {
      attrs: {
        "editable": _vm.$editFile(folder, _vm.currentPage) && _vm.canEdit,
        "is-admin": _vm.$adminFile(folder, _vm.currentPage),
        "is-owner": _vm.$ownerFile(folder, _vm.currentPage),
        "folder": folder,
        "folders": _vm.folders,
        "files": _vm.files,
        "in-neopass-form": _vm.currentPage.includes('/form/neopass/'),
        "smaller": _vm.currentPage.includes('/form/neopass/')
      },
      on: {
        "openFolder": function ($event) {
          return _vm.openFolder(folder);
        },
        "editFolder": function ($event) {
          return _vm.displayPopupEditFolder(true, folder);
        },
        "downloadFolder": function ($event) {
          return _vm.downloadAFolder(folder);
        },
        "deleteFolder": function ($event) {
          return _vm.displayPopupDeleteFolder(true, folder);
        },
        "moveFolder": function ($event) {
          return _vm.displayPopupMoveFile(true, folder);
        },
        "addMember": function ($event) {
          return _vm.displayPopupAddMember(true, folder);
        }
      }
    })], 1);
  }), 0), _vm._v(" "), _vm.files.length > 0 ? _c('div', {
    staticClass: "flex my-10"
  }, [_c('h4', {
    staticClass: "text-indigo-600 text-left"
  }, [_vm._v("\n        Fichiers récents\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow"
  }), _vm._v(" "), _c('h5', {
    staticClass: "text-gray-900 text-right cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.displayAllFiles();
      }
    }
  }, [_vm._v("\n        Voir tout\n      ")])]) : _vm._e(), _vm._v(" "), _vm.canEdit && _vm.$can(_vm.constants.PERMISSION_DEPOT_DOCUMENTS_CREATE) ? _c('add-button', {
    attrs: {
      "libelle": "Ajouter un nouveau fichier"
    },
    on: {
      "add": function ($event) {
        return _vm.changeStatePopupAddNewFile(1);
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.files.length > 0 ? _c('div', [_vm._m(0), _vm._v(" "), _vm._l(_vm.files.filter(function (f, i) {
    return i < 5;
  }), function (file, numFile) {
    return _c('div', {
      key: numFile,
      staticClass: "grid grid-cols-12 gap-x-4 h-16 lg:h-24 2xl:h-32 text-base items-center odd:bg-gray-300 odd:bg-opacity-50 px-12"
    }, [_c('div', {
      staticClass: "col-span-2 justify-self-center"
    }, [_c('tag', {
      attrs: {
        "responsive": "",
        "libelle": file.type.toUpperCase(),
        "theme-color": _vm.colorByType[file.type.toLowerCase()] ? _vm.colorByType[file.type.toLowerCase()] : 'default'
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-8 md:col-span-2"
    }, [_c('info-bulle-hover', {
      attrs: {
        "name": 'filename' + file.id,
        "libelle": file.name.substring(0, file.name.lastIndexOf('.')),
        "is-display-tooltip": _vm.isFilenameTooltipDisplay == file.id,
        "position": "bottom-3 left-0"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "truncate",
      on: {
        "mouseover": function ($event) {
          _vm.isFilenameTooltipDisplay = file.id;
        },
        "mouseleave": function ($event) {
          _vm.isFilenameTooltipDisplay = -1;
        }
      }
    }, [_vm._v("\n          " + _vm._s(file.name.substring(0, file.name.lastIndexOf('.'))) + "\n        ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 md:block hidden"
    }, [_c('info-bulle-hover', {
      attrs: {
        "name": 'parent' + file.id,
        "libelle": file.folder_id == null ? 'Mon dépôt de documents' : _vm.folders.filter(function (f) {
          return f.id == file.folder_id;
        }).length > 0 ? _vm.folders.filter(function (f) {
          return f.id == file.folder_id;
        })[0].name : 'Mon dépôt de documents',
        "is-display-tooltip": _vm.isParentFolderNameTooltipDisplay == file.id,
        "position": "bottom-3 left-0"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "truncate",
      on: {
        "mouseover": function ($event) {
          _vm.isParentFolderNameTooltipDisplay = file.id;
        },
        "mouseleave": function ($event) {
          _vm.isParentFolderNameTooltipDisplay = -1;
        }
      }
    }, [_vm._v("\n          " + _vm._s(file.folder_id == null ? 'Mon dépôt de documents' : _vm.folders.filter(function (f) {
      return f.id == file.folder_id;
    }).length > 0 ? _vm.folders.filter(function (f) {
      return f.id == file.folder_id;
    })[0].name : 'Mon dépôt de documents') + "\n        ")])], 1), _vm._v(" "), _c('list-avatars', {
      staticClass: "col-span-2 md:block hidden justify-self-center bottom-1/6",
      attrs: {
        "list-items": file.users,
        "libelle-firstname": "firstname",
        "libelle-lastname": "lastname"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 md:block hidden"
    }, [_vm._v("\n        " + _vm._s(new Date(file.created_at).toLocaleDateString()) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 justify-self-center"
    }, [_c('div', {
      staticClass: "cursor-pointer p-5 relative",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.displaySubMenuFile(file.id);
        }
      }
    }, [_c('icon', {
      staticClass: "text-pink-600",
      attrs: {
        "name": "more-vertical"
      }
    }), _vm._v(" "), _vm.subMenuFileNumber == file.id ? _c('div', {
      directives: [{
        name: "click-outside",
        rawName: "v-click-outside",
        value: _vm.hideSubMenuFile,
        expression: "hideSubMenuFile"
      }],
      staticClass: "absolute rounded-md bg-white shadow-lg shadow-gray-600 p-5 right-0 z-30"
    }, [_c('div', {
      staticClass: "flex flex-col space-y-2"
    }, [_vm.constants.FILE_TYPES.img.includes(file.type.toLowerCase()) || _vm.constants.FILE_TYPES.pdf.includes(file.type.toLowerCase()) ? _c('div', {
      staticClass: "cursor-pointer text-gray-600 hover:text-gray-900",
      on: {
        "click": function ($event) {
          return _vm.displayPopupPreview(true, file);
        }
      }
    }, [_vm._v("\n                Visualiser\n              ")]) : _vm._e(), _vm._v(" "), _vm.canEdit && _vm.$can(_vm.constants.PERMISSION_DEPOT_DOCUMENTS_MOVE) ? _c('div', {
      staticClass: "cursor-pointer text-gray-600 hover:text-gray-900",
      on: {
        "click": function ($event) {
          return _vm.displayPopupMoveFile(true, file);
        }
      }
    }, [_vm._v("\n                Déplacer\n              ")]) : _vm._e(), _vm._v(" "), _vm.$adminFile(file, _vm.currentPage) && _vm.$can(_vm.constants.PERMISSION_DEPOT_DOCUMENTS_SHARE) && !_vm.$freeParticulier() ? _c('div', {
      staticClass: "cursor-pointer text-gray-600 hover:text-gray-900",
      on: {
        "click": function ($event) {
          return _vm.displayPopupAddMember(true, file);
        }
      }
    }, [_vm._v("\n                Partager\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "cursor-pointer text-gray-600 hover:text-gray-900",
      on: {
        "click": function ($event) {
          return _vm.downloadAFile(file);
        }
      }
    }, [_vm._v("\n                Télécharger\n              ")]), _vm._v(" "), _vm.$editFile(file, _vm.currentPage) && _vm.$can(_vm.constants.PERMISSION_DEPOT_DOCUMENTS_EDIT) ? _c('div', {
      staticClass: "cursor-pointer text-gray-600 hover:text-gray-900",
      on: {
        "click": function ($event) {
          return _vm.displayPopupEditFile(true, file);
        }
      }
    }, [_vm._v("\n                Éditer\n              ")]) : _vm._e(), _vm._v(" "), _vm.$editFile(file, _vm.currentPage) && _vm.$can(_vm.constants.PERMISSION_DEPOT_DOCUMENTS_DELETE) ? _c('div', {
      staticClass: "cursor-pointer text-gray-600 hover:text-gray-900",
      on: {
        "click": function ($event) {
          return _vm.displayPopupDeleteFolder(true, file);
        }
      }
    }, [_vm._v("\n                Supprimer\n              ")]) : _vm._e()])]) : _vm._e()], 1)])], 1);
  })], 2) : _vm._e()], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 h-16 lg:h-24 2xl:h-32 text-gray-600 text-lg items-center px-12"
  }, [_c('div', {
    staticClass: "col-span-2 justify-self-center"
  }, [_vm._v("\n        Type\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-10 md:col-span-2"
  }, [_vm._v("\n        Nom du fichier\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "md:col-span-2 md:block hidden"
  }, [_vm._v("\n        Dossier parent\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "md:col-span-2 md:block hidden justify-self-center"
  }, [_vm._v("\n        Membres\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "md:col-span-2 md:block hidden"
  }, [_vm._v("\n        Date création\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 md:block hidden justify-self-center"
  }, [_vm._v("\n        Plus\n      ")])]);

}]

export { render, staticRenderFns }